import { Theme, createStyles, makeStyles } from '@material-ui/core';
import { blue, blueGrey, common, cyan, green, grey, orange, red, teal } from '@mui/material/colors';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            width: 280,
            display: 'flex',
            flex: '1',
            flexDirection: 'column',
            margin: '0 auto',
            padding: theme.spacing(1),
            '& div': {
                marginTop: theme.spacing(2),
            },
            '& button': {
                marginTop: theme.spacing(4),
            },
        },
        TypographyLeft: {
            flex: 1,
            display: 'flex',
            justifyContent: 'left',
            '& *': {
                marginRight: 10,
            },
        },
        TypographyCenter: {
            flex: 4,
            display: 'flex',
            justifyContent: 'center',
            '& *': {
                margin: 5,
            },
        },
        TypographyRight: {
            flex: 1,
            display: 'flex',
            justifyContent: 'right',
            '& *': {
                marginLeft: 10,
            },
        },
        appBar: {
            boxShadow: 'none',
            borderBottomWidth: 1,
            borderBottomStyle: 'solid',
            borderBottomColor: theme.palette.divider,
            backgroundColor: `${blueGrey[800]} !important`,
        },
        tree: {
            '& .MuiTreeItem-label': {
                width: 'unset !important',
                color: common.white,
            },
            '& .MuiTreeItem-iconContainer': { color: common.white },
            '& .MuiTreeItem-content': {
                marginTop: 8,
                marginBottom: 8,
            },
        },
        buttonBlue: {
            margin: 4,
            backgroundColor: `${blue[800]} !important`,
            color: '#fff !important',
            '&:hover': {
                backgroundColor: `${blue[900]} !important`,
            },
            '&.Mui-disabled': {
                color: `${grey[500]} !important`,
                backgroundColor: `${grey[300]} !important`,
            },
        },
        buttonTeal: {
            margin: 4,
            backgroundColor: `${teal[700]} !important`,
            color: '#fff !important',
            '&:hover': {
                backgroundColor: `${teal[800]} !important`,
            },
            '&.Mui-disabled': {
                color: `${grey[500]} !important`,
                backgroundColor: `${grey[300]} !important`,
            },
        },
        buttonCyan: {
            margin: 4,
            backgroundColor: `${cyan[800]} !important`,
            color: '#fff !important',
            '&:hover': {
                backgroundColor: `${cyan[900]} !important`,
            },
            '&.Mui-disabled': {
                color: `${grey[500]} !important`,
                backgroundColor: `${grey[300]} !important`,
            },
        },
        buttonGreen: {
            margin: 4,
            backgroundColor: `#03738C !important`,
            color: '#fff !important',
            '&:hover': {
                backgroundColor: `#274B59 !important`,
            },
            '&.Mui-disabled': {
                color: `${grey[500]} !important`,
                backgroundColor: `${grey[300]} !important`,
            },
        },
        buttonOrange: {
            margin: 4,
            backgroundColor: `${orange[800]} !important`,
            color: '#fff !important',
            '&:hover': {
                backgroundColor: `${orange[900]} !important`,
            },
            '&.Mui-disabled': {
                color: `${grey[500]} !important`,
                backgroundColor: `${grey[300]} !important`,
            },
        },
        buttonRed: {
            margin: 4,
            backgroundColor: `${red[700]} !important`,
            color: '#fff !important',
            '&:hover': {
                backgroundColor: `${red[800]} !important`,
            },
            '&.Mui-disabled': {
                color: `${grey[500]} !important`,
                backgroundColor: `${grey[300]} !important`,
            },
        },
        buttonWhite: {
            margin: 4,
            backgroundColor: `#FFFFFF !important`,
            color: `${common.black} !important`,
            '&:hover': {
                backgroundColor: `#E6F0F3 !important`,
            },
            '&.Mui-disabled': {
                color: `${grey[500]} !important`,
                backgroundColor: `${grey[300]} !important`,
            },
        },
        divHeader: { borderTop: '1px solid black', borderLeft: '1px solid black' },
        divCell: { borderBottom: '1px solid black', borderRight: '1px solid black' },
        summaryTable: {
            '& th': { fontWeight: 'bold', fontSize: 20 },
            '& td': { padding: 4, fontSize: 20 },
            '& th:nth-child(1), & td:nth-child(1)': { width: `${(100 / 13) * 5}%` },
            '& th:nth-child(2), & td:nth-child(2)': { width: `${(100 / 13) * 2}%` },
            '& th:nth-child(3), & td:nth-child(3)': { width: `${(100 / 13) * 2}%` },
            '& th:nth-child(4), & td:nth-child(4)': { width: `${(100 / 13) * 2}%` },
            '& th:nth-child(5), & td:nth-child(5)': { width: `${(100 / 13) * 2}%` },
            '& th:nth-child(n):not(:nth-last-child(-n+1)), & td:nth-child(n):not(:nth-last-child(-n+1))': {
                borderRight: '1px solid rgba(0, 0, 0, 0.1)',
            },
        },
    }),
);
